import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67da7226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invention-authorization" }

import { ref, onMounted, onUnmounted, computed, watch } from 'vue'
import * as echarts from 'echarts'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'
import TitleCpn from '../../../Title/TitleCpn.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InventionAuthorization',
  setup(__props) {

const center = ['25%', '50%']
const attributes = [
    {
        name: 'big',
        radius: ['50%', '70%'],
        opacity: 1,
    },
    {
        name: 'centre',
        radius: ['35%', '50%'],
        opacity: 0.8,
    },
    {
        name: 'small',
        radius: ['25%', '35%'],
        opacity: 0.7,
    }
]

const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)
const chartRef = ref()
const myChart = ref()
function arrCount(arr) {
    let count = 0
    arr.forEach(item => {
        count = count + item.value
    })
    return count
}
const option = computed(() => {
    const series: any = []
    if (data.value?.right2) {
        attributes.forEach((item) => {
            series.push({
                name: item.name,
                type: 'pie',
                radius: item.radius,
                center: center,
                zlevel: 3,
                hoverAnimation: false,
                label: {
                    show: false,
                },
                labelLine: {
                    show: false,
                },
                itemStyle: {
                    opacity: item.opacity,
                },
                data: data.value!.right2,
            },)
        })
    }
    return {
        legend: [{
            show: true,
            orient: '',
            icon: 'circle',
            left: '50%',
            top: 'center',
            itemWidth: 16,
            itemHeight: 16,
            itemGap: 20,
            data: data.value?.right2.map(item => item.name) || [],
            textStyle: {
                padding: [0, 0, 0, 10],
                color: "#fff",
                fontSize: '1.4rem',
                rich: {
                    a: {
                        fontSize: 14,
                        width: 70
                    },
                    b: {
                        fontSize: 14,
                        width: 60,
                        color: '#c1c1c1'
                    },
                    c: {
                        fontSize: 14
                    }
                }

            },
            formatter(name: any) {
                const count = arrCount(data.value?.right2)
                //找到data中name和文本name值相同的对象
                const val = data.value?.right2.filter(item => {
                    return item.name === name
                })
                var arr = [
                    '{a|' + name + '}',
                    '{b|' + ((val[0].value / count) * 100).toFixed(2) + '%}',
                    '{c|' + val[0].value + '}'
                ]
                return arr.join('  ')

                // return name + '  ' + ((val[0].value / count) * 100).toFixed(2) + '%' + '  ' + val[0].value
            }
        }],
        series: series
        // series: [
        //     {
        //         name: 'big',
        //         type: 'pie',
        //         radius: ['50%', '70%'],
        //         center: center,
        //         zlevel: 3,
        //         hoverAnimation: false,
        //         label: {
        //             show: false,
        //         },
        //         labelLine: {
        //             show: false,
        //         },
        //         itemStyle: {
        //             opacity: 1,
        //         },
        //         data: data.map(item => {
        //             return {
        //                 name: item.name,
        //                 value: item.value,
        //                 itemStyle: {
        //                     normal: {
        //                         color: item.color,
        //                     },
        //                 },
        //             }
        //         }),
        //     },
        //     {
        //         name: 'centre',
        //         type: 'pie',
        //         radius: ['35%', '50%'],
        //         center: center,
        //         zlevel: 2,
        //         label: {
        //             show: false,
        //             position: 'center',
        //         },
        //         labelLine: {
        //             show: false,
        //         },
        //         itemStyle: {
        //             opacity: 0.8,
        //         },
        //         data: data.map(item => {
        //             return {
        //                 name: item.name,
        //                 value: item.value,
        //                 itemStyle: {
        //                     normal: {
        //                         color: item.color,
        //                     },
        //                 },
        //             }
        //         }),
        //     },
        //     {
        //         name: 'small',
        //         type: 'pie',
        //         radius: ['25%', '35%'],
        //         center: center,
        //         zlevel: 2,
        //         label: {
        //             show: false,
        //             position: 'center',
        //         },
        //         labelLine: {
        //             show: false,
        //         },
        //         itemStyle: {
        //             opacity: 0.7,
        //         },
        //         data: data.map(item => {
        //             return {
        //                 name: item.name,
        //                 value: item.value,
        //                 itemStyle: {
        //                     normal: {
        //                         color: item.color,
        //                     },
        //                 },
        //             }
        //         }),
        //     },
        // ],
    }
})

onMounted(() => {
    window.addEventListener('resize', handleResize)
})
onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

const handleResize = () => {
    myChart.value?.resize()
}

const createChart = async () => {
    myChart.value = echarts.init(chartRef.value);
    myChart.value.setOption(option.value);
}

onMounted(() => {
    setTimeout(() => {
        createChart()
    }, 500)
})

watch(
    option,
    () => { myChart.value?.setOption(option.value) },
    { immediate: true }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleCpn, { title: "申请人类型占比" }),
    _createElementVNode("div", {
      class: "chart-container",
      ref_key: "chartRef",
      ref: chartRef
    }, null, 512)
  ]))
}
}

})